var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "AxWhatsNewPanel", staticClass: "ax-whats-new-panel" },
    [
      _vm.isWhatsNewPanelOpen
        ? _c("div", {
            staticClass: "whatsnew-backdrop",
            on: { click: _vm.closeWhatsNew }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "SlidingPanel",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isWhatsNewPanelOpen,
              expression: "isWhatsNewPanelOpen"
            }
          ],
          ref: "AxWhatsNewPanel",
          staticClass: "whats-new-panel",
          attrs: { id: "WhatsNewPanel", enterFrom: "right", isFullHeight: true }
        },
        [
          _c("p", { staticClass: "ax-whats-new-panel__heading" }, [
            _vm._v("Whats New")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "whats-new-list" }, [
            _c("div", { staticClass: "item" }, [
              _c("iframe", {
                attrs: {
                  frameBorder: "0",
                  src: "http://127.0.0.1:28080/html/ax-whatsnew-learnmore.html"
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item" }, [
              _c("iframe", {
                attrs: {
                  frameBorder: "0",
                  src: "http://localhost:28080/html/ax-whatsnew-shortcut.html"
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item" }, [
              _c("iframe", {
                attrs: {
                  frameBorder: "0",
                  src: "http://localhost:28080/html/ax-whatsnew-idea.html"
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item" }, [
              _c("iframe", {
                attrs: {
                  frameBorder: "0",
                  src: "http://localhost:28080/html/ax-whatsnew-efficient.html"
                }
              })
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }